import React, { useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import './thankyou.css'

const ThankYou = ({ currentUser, fromWebApp, }) => {
  const showLink = !currentUser.lpsIsComplete
  const history = useHistory()
  const params = useParams()
  const { token } = params

  const close = useCallback(() => {
    fromWebApp ? window.location.href = '/homepage?refresh=true' : location.href = window.callbackUrl
  },[fromWebApp])

  const submit = useCallback(() => {
    // if virtual, return to the sessions
    if (window.currentEvent.is_virtual_event) {
      history.push('/' + token)
    // if in person, return to app
    } else {
      window.location = window.location.origin
    }
  },[token])

  return(
    <div className='thankyou-page wizard-form'>
      <h1>Your peer-to-peer meeting setup is complete!</h1>
      {window.visitingOneOnOneWizardFrom == 'app' || fromWebApp ?
        <div>
          <p>To return to the App, please click the button below.</p>
          <br />
          <div className='bottom-buttons margin-top-10'>
            { showLink && (
              <div>
                <a href={currentUser.lpsSurveyLink}
                  target='_blank'
                  rel="noopener noreferrer" >
                    Complete Leadership Perspective Survey <i className="fa fa-external-link"></i>
                </a>
              </div>
            )}
          </div>
          <div className='bottom-buttons margin-top-10'>
            <button
              onClick={close}
              className='submit light-base'>
              Close
            </button>
          </div>
        </div>
        :
        <div>
          <p>You can return to the portal to update your information anytime. We’ll do our best to match you with your selections and you will receive an email when the meetings are finalized closer to the summit date.</p>
          <p>If you would like to select your sessions now, please continue via the button below.</p>
          <div className='bottom-buttons margin-top-10'>
            { showLink && (
              <div>
                <a href={currentUser.lpsSurveyLink}
                  target='_blank'
                  rel="noopener noreferrer" >
                    Complete Leadership Perspective Survey <i className="fa fa-external-link"></i>
                </a>
              </div>
            )}
            <br />
            <button
              onClick={submit}
              className='submit light-base'>
              VIEW SESSIONS
            </button>
          </div>
        </div>
      }
    </div>
  )
}

export default ThankYou